var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgecolor2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 56,
    viewBox: "0 0 46 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4544 26.1836V54.5454C35.4544 55.5508 34.449 56.242 33.5064 55.9069L25.4628 53.0372C23.8709 52.4716 22.1323 52.4716 20.5404 53.0372L12.4759 55.9069C11.5333 56.242 10.5488 55.5508 10.5488 54.5454V26.1836H35.4544Z",
    fill: "url(#paint0_linear_674_51739)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_674_51739",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 26,
    width: 26,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5206 55.9171L25.4624 53.0453C23.8726 52.4797 22.134 52.4797 20.5441 53.0453L12.486 55.9171C11.5434 56.2522 10.5547 55.5547 10.5547 54.5556V26.1875H35.4519V54.5556C35.4519 55.5547 34.4611 56.2522 33.5206 55.9171Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_674_51739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9329 23.9629H31.873V59.7817H42.9329V23.9629Z",
    fill: "#EA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1321 23.9629H3.07227V59.7817H14.1321V23.9629Z",
    fill: "#EA4F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4909 23.9629H19.5156V59.7817H26.4909V23.9629Z",
    fill: "url(#paint1_linear_674_51739)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4544 26.1836V37.1596C32.0401 40.3854 27.8089 42.5429 23.0121 42.5429C18.1944 42.5429 13.9631 40.3854 10.5488 37.1596V26.1836H35.4544Z",
    fill: "#F2E07C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3564 8.73475C41.5495 1.8433 33.6527 0 22.9908 0C12.3499 0 4.45302 1.8433 1.64617 8.73475C-1.83097 17.281 7.4484 41.6838 22.9908 41.6838C38.5542 41.6838 47.8335 17.281 44.3564 8.73475Z",
    fill: "url(#paint2_linear_674_51739)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08658 9.0699C4.89343 2.17845 12.7903 0.335148 23.4312 0.335148C30.9092 0.335148 37.0047 1.23585 40.9636 4.16838C37.0256 0.984491 30.7416 0 22.9913 0C12.3504 0 4.45355 1.8433 1.6467 8.73475C-1.03447 15.2911 3.82515 31.1896 13.2511 38.2276C4.09746 31.0429 -0.552699 15.5215 2.08658 9.0699Z",
    fill: "#FFF1CC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9906 38.6464C16.4553 38.6464 11.7842 33.1375 9.58478 29.8698C5.66775 24.0466 2.60954 14.4111 4.45285 9.88666C6.40089 5.06893 11.9517 3.03711 22.9906 3.03711C34.0505 3.03711 39.6013 5.06893 41.5494 9.88666C43.3927 14.4111 40.3345 24.0466 36.4174 29.8698C34.218 33.1375 29.5469 38.6464 22.9906 38.6464Z",
    fill: "#D6BC91"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9908 38.2285C16.6649 38.2285 12.0985 32.8242 9.94101 29.6194C5.14423 22.4975 3.40566 13.5743 4.85098 10.0343C6.73617 5.42602 12.1614 3.45703 22.9908 3.45703C33.8411 3.45703 39.2663 5.42602 41.1515 10.0343C42.5968 13.5743 40.8583 22.4975 36.0615 29.6194C33.904 32.8242 29.3376 38.2285 22.9908 38.2285Z",
    fill: "url(#paint3_linear_674_51739)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4304 34.7494C18.906 34.7494 15.3241 30.4553 13.6065 27.8789C8.9982 21.0293 8.20222 13.6142 8.89346 11.9385C9.60565 10.158 11.9098 7.79102 23.4304 7.79102C34.9511 7.79102 37.2552 10.158 37.9884 11.9385C38.6587 13.6142 37.8627 21.0293 33.2544 27.8789C31.5368 30.4553 27.9759 34.7494 23.4304 34.7494Z",
    fill: "#F2DC7C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9908 34.3308C18.4663 34.3308 14.9053 30.0158 13.1668 27.4604C8.55851 20.5898 7.78349 13.1747 8.45378 11.5199C9.18691 9.71853 11.4701 7.35156 22.9908 7.35156C34.5114 7.35156 36.8155 9.71853 37.5487 11.5199C38.219 13.1747 37.4439 20.5898 32.8357 27.4604C31.0971 30.0158 27.5362 34.3308 22.9908 34.3308Z",
    fill: "url(#paint4_linear_674_51739)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7789 30.6039C5.9821 23.4611 4.24352 14.5588 5.68884 11.0188C7.57404 6.41051 12.9992 4.44152 23.8496 4.44152C32.2911 4.44152 37.444 5.63548 40.2089 8.3376C37.7163 4.94424 32.3958 3.45703 22.9908 3.45703C12.1614 3.45703 6.73617 5.42602 4.85098 10.0343C3.40566 13.5743 5.14423 22.4975 9.94101 29.6194C10.5694 30.541 11.3863 31.6512 12.3918 32.7614C11.7634 31.9864 11.2188 31.2532 10.7789 30.6039Z",
    fill: "#F2DC7C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5273 55.1312L25.4628 52.2406C23.8709 51.675 22.1323 51.675 20.5404 52.2406L12.4759 55.1312C11.5333 55.4664 10.5488 54.7542 10.5488 53.7697V54.5447C10.5488 55.5501 11.5333 56.2414 12.4759 55.9062L20.5404 53.0366C22.1323 52.471 23.8709 52.471 25.4628 53.0366L33.5273 55.9062C34.4699 56.2414 35.4544 55.5501 35.4544 54.5447V53.7697C35.4544 54.7542 34.4699 55.4664 33.5273 55.1312Z",
    fill: "#EBB059"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9307 23.1664C32.2922 17.6993 29.0455 14.306 27.4745 13.0282C27.2231 12.8187 26.867 13.0073 26.888 13.3424C26.9718 15.3114 24.6048 16.3378 23.725 13.5519C22.9081 10.9754 20.9391 10.6822 19.7871 10.766C19.3891 10.7869 19.1377 11.164 19.2634 11.541C19.5357 12.3579 19.6404 13.908 17.7343 15.9817C15.9957 17.8878 15.5977 20.192 15.5977 21.8677C15.5768 26.7064 19.5357 29.0733 23.4318 29.0733C27.1812 29.0733 30.03 26.7064 30.9307 23.1664Z",
    fill: "#F7D79C"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5107 22.35C31.8722 16.8829 28.6464 13.4896 27.0754 12.1909C26.8241 12.0023 26.468 12.1909 26.468 12.5051C26.5518 14.495 24.1848 15.5214 23.305 12.7355C22.4881 10.159 20.5191 9.86578 19.3671 9.94957C18.99 9.97052 18.7177 10.3476 18.8434 10.7246C19.1157 11.5206 19.2204 13.0916 17.3352 15.1653C15.5967 17.0505 15.1987 19.3756 15.1777 21.0303C15.1777 25.89 19.1157 28.2569 23.0327 28.2569C26.7612 28.2569 29.6309 25.89 30.5107 22.35Z",
    fill: "url(#paint5_linear_674_51739)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5041 19.2719C21.0642 19.7537 20.5615 20.2145 20.2054 20.7801C19.3885 22.0788 19.6608 24.0059 21.0642 24.8019C21.4831 25.0532 21.9649 25.1789 22.4676 25.2208C24.1433 25.3255 25.84 24.2154 26.238 22.7072C26.3637 22.2254 26.3637 21.7018 26.3009 21.1781C26.0914 19.628 25.1907 18.1827 23.892 17.1773C23.4102 16.8002 22.6771 16.1718 22.4048 16.8002C22.2581 17.1144 22.4676 17.7009 22.3 18.1199C22.1115 18.5388 21.8183 18.9159 21.5041 19.2719Z",
    fill: "url(#paint6_linear_674_51739)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_674_51739",
    x1: 40.8526,
    y1: 33.6385,
    x2: 40.8526,
    y2: 56.0089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#FF9B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE37D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_674_51739",
    x1: 115.138,
    y1: 27.8757,
    x2: 116.405,
    y2: 55.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_674_51739",
    x1: 42.1055,
    y1: -4.64555,
    x2: 47.7434,
    y2: 41.8671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_674_51739",
    x1: 36.6731,
    y1: -5.64366,
    x2: 48.2235,
    y2: 35.9377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_674_51739",
    x1: 33.3614,
    y1: 0.272432,
    x2: 42.3672,
    y2: 32.6932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE37D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_674_51739",
    x1: 29.504,
    y1: 4.04618,
    x2: 41.2182,
    y2: 20.3527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_674_51739",
    x1: 27.8344,
    y1: 13.413,
    x2: 31.6234,
    y2: 25.9085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgecolor2);
export default __webpack_public_path__ + "static/media/badgecolor2.63184fa6a990805e209858723b904657.svg";
export { ForwardRef as ReactComponent };